import { Component, OnInit, Input, Output } from '@angular/core';
import { AccountsService } from '../../services/accounts/accounts.service';
import { RechargesService } from '../../services/recharges/recharges.service';
import { MatSnackBar } from '@angular/material';
import { ToastComponent } from '../toast/toast.component';

@Component({
    selector: 'app-balance-box',
    templateUrl: './balance-box.component.html',
    styleUrls: ['./balance-box.component.scss']
})
export class BalanceBoxComponent implements OnInit {

    public account = {
        saldo : 0,
        preco_cel : 0,
        preco_fixo : 0
    };

    public loading = false;


    constructor(
        public accountsService:AccountsService,
        public rechargesService: RechargesService,
        private snackBar: MatSnackBar
    ) { }

    ngOnInit() {
        this.accountsService.infos().subscribe((res)=>{
            this.account = res.data;
        })
    }

    getAutonomyCel(){
        return this.account.saldo/this.account.preco_cel;
    }

    getAutonomyFixed(){
        return this.account.saldo/this.account.preco_fixo;
    }

    recharge(){
        this.loading = true;
        this.rechargesService.createLink().subscribe((res)=>{
            this.loading = false;
            if (res.success) {
                window.open(res.link, '_blank');
            } else {
                this.snackBar.openFromComponent(ToastComponent, {
                    data: "res.msg"
                });
            }
        })
    }

}
